import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import AnalyticsDashboard from './AnalyticsDashboard'; // Justera sökvägen om filen ligger i en annan mapp
import Login from './Login';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing session on load
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setUser(session?.user || null);
      setLoading(false);
      
      // Set up auth listener for changes in auth state
      const { data: authListener } = supabase.auth.onAuthStateChange(
        (event, session) => {
          setUser(session?.user || null);
        }
      );
      
      // Clean up subscription on unmount
      return () => {
        authListener.subscription.unsubscribe();
      };
    };
    
    checkSession();
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-indigo-600"></div>
      </div>
    );
  }

  return (
    <div>
      {user ? (
        <>
          <div className="bg-indigo-700 text-white p-4 shadow-md">
            <div className="container mx-auto flex justify-between items-center">
              <h1 className="text-xl font-bold">Daily Weird Win Admin</h1>
              <button 
                onClick={handleLogout}
                className="bg-indigo-800 hover:bg-indigo-900 text-white px-4 py-2 rounded-md text-sm"
              >
                Log Out
              </button>
            </div>
          </div>
          <AnalyticsDashboard user={user} />
        </>
      ) : (
        <Login onLogin={setUser} />
      )}
    </div>
  );
}

export default App;